import { UserBookingDetailsQuery } from '@website/types/graphqlOperations';
import ListTripFaqs from '../../../trips/TripsPage/ListTripFaqs';

/**
 * User Booking Details - FAQs
 */
export default function BookingTripsFAQsDetails({
  booking,
}: {
  booking: Pick<UserBookingDetailsQuery['booking'], 'trip'>;
}) {
  return (
    <div className="text-block">
      <ListTripFaqs
        title="Trip Info"
        faqs={booking.trip.faqs.items}
        showLinks
        showVideos
        subTitleClassName="h6 mt-4"
        titleClassName="h5 mb-4"
        notice={booking.trip.notice}
      />
    </div>
  );
}
